import PicPro from '../lib/picpro.js'

export default {
  data: () => ({
    imageSource: null,
    canvas: null,
    orientation: null,
    quality: 0.85,
    size: 640
  }),
  methods: {
    captureImage () {
      const img = this.$refs.img
      const magnification = Math.max(1, (img.width > img.height ? img.width : img.height) / this.size)
      this.canvas = this.$refs.canvas
      const picpro = new PicPro(this.canvas)
      picpro.drawPic(img, magnification, this.orientation)
      picpro.filter('sharp', 'soft')
      // picpro.filter('reverse')
      this.enqueue()
    },
    loadImage (e) {
      const file = e.srcElement.files[0]
      const fr = new FileReader()
      fr.addEventListener('load', () => {
        this.orientation = PicPro.getOrientation(fr.result)
        this.imageSource = PicPro.arrayBufferToDataURL(fr.result)
      })
      fr.readAsArrayBuffer(file)
    },
    enqueue () {
      const image = {
        source: this.canvas.toDataURL('image/jpeg', this.quality)
      }
      this.$store.commit('enqueueImageSource', image)
    }
  },
  template: `
<div id="image-capture">
  <input class="button" type="file" @change="loadImage">
  <img class="image-source" ref="img" v-if="imageSource" :src="imageSource" @load="captureImage" style="max-width: none; display: none;">
  <canvas ref="canvas"></canvas>
</div>
`
}



// WEBPACK FOOTER //
// ./src/components/image-capture.js